export default __webpack_public_path__ + "static/media/flying-airplanes.7e362731.png";